import ApplicationSerializer from "./application";

export default class BlockStorageVolumeSerializer extends ApplicationSerializer {
  usesProxy = true;

  attrs = {
    project: "projectkey",
    dataCenter: "datacenterkey",
    sizeInGib: "sizeingib",
    createdAt: "createdat",
    updatedAt: "updatedat",
  };

  serialize() {
    let json = super.serialize(...arguments);

    json.datacenter = json.datacenterkey;
    delete json.datacenterkey;

    json.tier = json.tier.slug;

    return json;
  }
}
